import { closePopupGtmTag } from '../libs/gtm';
import { activateFocusTrap, deactivateFocusTrap } from '../utils/focus-trap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { AutopaymentModal } from '../../components/popups/v1/AutopayModal/AutopayModal';
import { showAutopaymentModal } from '../../components/popups/v1/AutopayModalNew/scripts';
import { showUpSaleModal } from '../../components/popups/v1/UpSaleModal/scripts'
import { showOrderModal } from '../../components/popups/v1/OrderModal/scripts'

window.activePopups = [];

const closePopup = () => {
  if (window.activePopups.length === 0) {
    return;
  }

  const {popup, callback} = window.activePopups.pop();

  callback && callback();
  deactivateFocusTrap(popup);
  popup.classList.remove('js-popup--active');
  enableBodyScroll(popup);

  if (window.activePopups.length === 0) {
    document.removeEventListener('keydown', escPressHandler);
    document.body.classList.remove('ios-safari-overflow'); // fix for iOS
  }
};

const checkClosePopupEvent = (evt) => {
  const target = evt.target;
  const parent = target.closest('.js-popup__close, .js-popup');
  const isButtonClose = parent ? Boolean(parent.closest('.js-popup__close')) : false;

  return target === parent || isButtonClose;
};

const closePopupEvent = (evt) => {
  if (checkClosePopupEvent(evt)) {
    closePopup();
    closePopupGtmTag();
  }
};

const escPressHandler = (evt) => {
  if (evt.key === 'Escape' || evt.key === 'Esc') {
    closePopup();
  }
};

const showPopup = (popup, callback) => {
  window.activePopups.push({popup, callback});

  // fix for iOS
  document.querySelector('body').classList.add('ios-safari-overflow');
  disableBodyScroll(popup, {
    allowTouchMove: el => el.closest('.iti__country-list')
  });

  popup.classList.add('js-popup--active');

  activateFocusTrap(popup);
  popup.focus();

  popup.addEventListener('click', closePopupEvent);
  document.addEventListener('keydown', escPressHandler);
};

const showAutopaymentPopup = (blockName) => {
  const template = document.querySelector('#autopayment');
  const templateNew = document.querySelector('#auto-payment-form');

  if (window.paymentAbTestPromise) {
    window.paymentAbTestPromise.finally(() => {
      if (window.paymentAbTestGroup && window.paymentAbTestGroup !== 'A' && templateNew) {
        const upSaleTemplate = document.querySelector('#up-sale-form')?.content.cloneNode(true).querySelector('.up-sale-form')
        const autopaymentModal = templateNew.content.cloneNode(true).querySelector('.auto-payment-form');

        if (upSaleTemplate && window.paymentAbTestGroup === 'C') {
          showUpSaleModal(upSaleTemplate, {
            submitHandler: (nomenclatureId) => showAutopaymentModal(autopaymentModal, { nomenclatureId }),
            type: 'consult',
            blockName
          })

          return
        }

        showAutopaymentModal(autopaymentModal, {
          nomenclatureId: landingInfo.nomenclature_ID, // eslint-disable-line
          type: 'consult'
        })
      } else if (template) {
        const autopaymentPopup = template.content.cloneNode(true).querySelector('.autopayment-popup__wrapper');
        new AutopaymentModal(autopaymentPopup).init()
      } else {
        window.Sentry.captureException('Autopayment popup is required');
      }
    })
  } else if (template) {
    const autopaymentPopup = template.content.cloneNode(true).querySelector('.autopayment-popup__wrapper');
    new AutopaymentModal(autopaymentPopup).init()
  }
};

// TODO: Вспомогательная функция на время теста ABExperimentPayments
const showOrderPopup = (blockName) => {
  if (window.paymentAbTestPromise) {
    window.paymentAbTestPromise.finally(() => {
      if (window.paymentAbTestGroup === 'C') {
        showOrderModal({
          header: {
            title: 'Записаться на курс',
            description: null
          },
          blockName
        })

        return
      }

      showOrderModal({ blockName })
    })

    return
  }

  showOrderModal({ blockName })
}

export { closePopup, checkClosePopupEvent, showPopup, showAutopaymentPopup, showOrderPopup };
